import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { ProfileRead } from '../../shared/profile-read.model';
import { VerticalService } from 'src/app/vertical/shared/vertical.service';
import { VerticalTypeEnum } from 'src/app/vertical/shared/vertical-type.enum';
import { NahbProfileTypeEditComponent } from './nahb-profile-type-edit/nahb-profile-type-edit.component';
import { NaaProfileTypeEditComponent } from './naa-profile-type-edit/naa-profile-type-edit.component';

@Component({
  selector: 'wl-profile-edit-profile-type',
  templateUrl: './profile-edit-profile-type.component.html',
  styleUrls: ['./profile-edit-profile-type.component.less'],
    standalone: false
})
export class ProfileEditProfileTypeComponent implements OnInit {
  @Input()
  get profile() {
    return this._profile;
  }
  set profile(value: ProfileRead) {
    this._profile = value;
    this.profileChange.emit(this._profile);
  }
  @Output() profileChange: EventEmitter<ProfileRead> = new EventEmitter();

  @ViewChild(NaaProfileTypeEditComponent) _naaProfileTypeEditComponent: NaaProfileTypeEditComponent;

  verticalType: VerticalTypeEnum;
  verticalTypeEnum = VerticalTypeEnum;
  private _profile: ProfileRead;
  constructor(private _verticalService: VerticalService) {
    this.profile = new ProfileRead();
  }

  ngOnInit(): void {
    this._verticalService.GetCurrentUserVerticalType().then((verticalType) => {
      this.verticalType = verticalType;
    });
  }

  public save(): Promise<number | void>[] {
    if (this._naaProfileTypeEditComponent) {
      return this._naaProfileTypeEditComponent.save();
    } else {
      return [];
    }
  }
}
